document.addEventListener("DOMContentLoaded", () => {
    const tabsBlock = document.querySelectorAll(".wp-block-klingit-basic-pricing-tabs");

    tabsBlock.forEach(tabs => {
        const tabContents = tabs.querySelectorAll(".wp-block-klingit-basic-pricing-tab");

        const desktopNavigation = document.createElement("div");
        desktopNavigation.classList.add("tabs-navigation");

        tabContents.forEach((tabContent, i) => {
            const button = tabContent.querySelector("button");

            if (i == 0) {
                tabContent.classList.add("is-visible");
            }
            desktopNavigation.appendChild(button.cloneNode(true));
        });

        tabs.prepend(desktopNavigation);

        const buttons = tabs.querySelectorAll("button[data-button]");
        const navButtons = tabs.querySelectorAll(".tabs-navigation button[data-button]");
        navButtons[0].classList.add("is-active");

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const id = button.getAttribute("data-button");

                if (button.classList.contains("is-active")) {
                    if (desktopNavigation.classList.contains("is-active")) {
                        desktopNavigation.classList.remove("is-active");
                    } else {
                        desktopNavigation.classList.add("is-active");
                    }

                    navButtons.forEach((navButton, j) => {
                        navButton.style.top = navButton.getBoundingClientRect().height * j + 'px';
                    });
                } else {
                    desktopNavigation.classList.remove("is-active");
                }

                tabContents.forEach((tabContent, i) => {
                    const content = tabContent.querySelector(".tab-content");

                    if (content.getAttribute("data-tab") === id) {
                        tabContent.classList.add("is-visible");
                        navButtons[i].classList.add("is-active");
                    } else {
                        tabContent.classList.remove("is-visible");
                        navButtons[i].classList.remove("is-active");
                    }
                });
            });
        });

        document.addEventListener("click", (e) => {
            if (!desktopNavigation.contains(e.target)) {
                desktopNavigation.classList.remove("is-active");
            }
        });
    });
});